// import { first } from 'lodash'
import { UploadIcon, XIcon } from '@heroicons/react/outline'
import produce from 'immer'
import { forwardRef, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import {
    formatuseFormErrors,
    getMimeTypes,
    log,
    textForTypes,
} from '../../helpers/utils'
import ErrorAlert from '../Alerts/ErrorAlert'

const isImage = (file) => file.type.startsWith('image/')

const Fileupload = forwardRef(({ ...props }, ref) => {
    const {
        item,
        callback,
        onDelete,
        errors,
        name: nameFromProp,
        setValue,
        shouldReset,
        maxFiles,
    } = props
    const { label } = item

    const name = nameFromProp || item.name

    const [localErrors, setLocalErrors] = useState([])
    const [files, setFiles] = useState([])

    const makeAllowdTypes = (types) => {
        let allowedTypes = []
        allowedTypes = types.map((type) => {
            return getMimeTypes(type)
        })
        return allowedTypes.toString()
    }

    const getTextTypes = (types) => {
        let allowedTypes = []
        allowedTypes = types.map((type) => {
            return textForTypes[type]
        })
        return allowedTypes.toString()
    }

    const allowedTypes = Array.isArray(item.allowed_types)
        ? makeAllowdTypes(item.allowed_types)
        : getMimeTypes(item.allowed_types)
    const textTypes = Array.isArray(item.allowed_types)
        ? getTextTypes(item.allowed_types)
        : textForTypes[item.allowed_types]

    useEffect(() => {
        setFiles([])
    }, [shouldReset])

    const handleLocalFiles = (files) => {
        setFiles(
            produce((draft) => {
                draft.push(...files)
                draft.reverse()
                maxFiles && draft.splice(maxFiles)
                updateFieldValue([...draft])
            }),
        )
    }

    const getFreshFiles = (newFiles) => {
        const freshFiles = []
        let filePaths = files.map((file) => file.path)
        newFiles.forEach((file) => {
            if (!filePaths.includes(file.path)) freshFiles.push(file)
        })
        return freshFiles
    }

    const deleteFile = (name) => {
        setFiles(
            produce((draft) => {
                const files = draft.filter((file) => file.path !== name)
                updateFieldValue(files)
                return files
            }),
        )
        if (onDelete) onDelete(name)
    }

    const handledropFiles = (files) => {
        handleLocalFiles(files)
        if (callback) callback(files)
    }

    const updateFieldValue = (files) => {
        // if (files.length > 1) return
        setValue(name, files)
        log('updateFieldValue', files)
        maxFiles === 1 ? setValue(name, files[0]) : setValue(name, files)
    }

    const onDropAccepted = (files) => {
        setLocalErrors([])
        const freshFiles = getFreshFiles(files)
        handledropFiles(freshFiles)
    }

    const onDropRejected = (files) => {
        let errorsArray = []
        files.map(({ errors }) => {
            if (errors && !errorsArray.includes(errors[0]))
                errorsArray.push(errors[0])
        })
        setLocalErrors(errorsArray)
    }

    const { getRootProps, getInputProps } = useDropzone({
        onDropAccepted,
        onDropRejected,
        accept: allowedTypes,
        // maxFiles,
    })

    const listFiles = files.map((file) => {
        return (
            <li
                className="p-2  border bg-white rounded m-2 shadow flex justify-between items-center"
                key={file.path}>
                {isImage(file) ? (
                    <>
                        <img
                            className="h-28"
                            src={URL.createObjectURL(file)}
                            alt={file.path}
                        />
                    </>
                ) : (
                    <>
                        <span>{file.path}</span>
                    </>
                )}
                <button type="button" onClick={() => deleteFile(file.path)}>
                    <XIcon className="h-4 text-red-600"></XIcon>
                </button>
            </li>
        )
    })

    return (
        <>
            <div {...getRootProps()} className="pb-4">
                <div className="space-y-2 text-olm ">
                    <input
                        data-input-id={item.name}
                        ref={ref}
                        {...getInputProps()}
                    />
                    <label
                        htmlFor={label || item.name}
                        className="block text-sm font-medium text-olm-black sm:mt-px sm:pt-2">
                        {label || item.name}
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                        <div
                            className={`
        ${errors?.[name] ? 'border-red-500' : 'border-gray-300 text-olm'}
        flex justify-center px-6 pt-2 pb-3 border-2 border-dashed rounded-md`}>
                            <div className="space-y-1 text-center justify-center">
                                <UploadIcon className="mx-auto h-5 w-5"></UploadIcon>
                                <div className="text-sm text-olm flex justify-center">
                                    <div className="relative underline cursor-pointer text-olm rounded-md font-medium focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 ">
                                        <span>Upload a file</span>
                                        <input
                                            id="file-upload"
                                            type="file"
                                            className="sr-only"
                                        />
                                    </div>
                                    <p className="pl-1">or drag and drop</p>
                                </div>
                                <p className="text-xs text-gray-500  tracking-wide">
                                    Allowed files{' '}
                                    <span className="uppercase">
                                        {textTypes}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul>{listFiles}</ul>

            {localErrors.length > 0 && (
                <ErrorAlert error={formatuseFormErrors(localErrors)} />
            )}
            {/* localErrors.map(({ message }, idx) => (
                    <div key={message + idx}>{message}</div>
                ))} */}
        </>
    )
})

Fileupload.displayName = 'FileUpload'

export { Fileupload }
